<template>
	<div>
		<v-navigation-drawer
			class="pa-0"
			fixed
			height="auto"
			right
			temporary
			stateless
			:width="width"
			v-model="value"
		>
			<section class="header-modal">
				<header class="header-title">
					<div class="header-heading">
						<span class="header-icon"><v-icon>tune</v-icon></span>
						<div><small>FORMULARIO</small><h2>{{ title }}</h2></div>
					</div>
					<v-btn
						class="modal-close ma-0"
						flat icon
						:disabled="isLoading"
						@click="closeDrawer"
					>
						<v-icon>close</v-icon>
					</v-btn>
				</header>
			</section>
			<section class="content-modal">
				<slot></slot>
			</section>
		</v-navigation-drawer>
	</div>
</template>

<script>
function closeDrawer() {
	this.$emit('close-modal', false);
}

export default {
	name: 'action-sidebar',
	methods: {
		closeDrawer,
	},
	model: {
		prop: 'value',
		event: 'close-modal',
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		value: {
			type: Boolean,
			required: true,
		},
		width: {
			type: Number,
			default: 600,
		},
		codeAction: {
			type: String,
			required: false,
		},
		imgSrc: {
			type: String,
		},
		headerColor: {
			type: String,
			default: 'white',
		},
		isLoading: {
			default: false,
			type: Boolean,
		},
	},
};
</script>

<style lang="scss" scoped>
.navigation-drawer{
	background: #f6f8fb;
	box-shadow: -14px 0 36px rgba(23, 46, 69, .16) !important;
	height: 100%;
	padding: 0;
}
	.header-modal {
		background: white;
		border-bottom: 1px solid #e0e8ef;
		box-shadow: 0 3px 12px rgba(35, 58, 81, .05);
		min-height: 66px;
		padding: 9px 14px;
		.header-title {
			@include flex-between;
			height: 48px;

			.header-heading { align-items: center; display: flex; gap: 10px; min-width: 0; }
			.header-icon {
				align-items: center; background: #EAF3EF; border-radius: 9px; display: flex;
				height: 36px; justify-content: center; width: 36px;
				.icon { color: #1A4338; font-size: 19px; }
			}
			small { color: #7e92a4; display: block; font-size: 8px; font-weight: 700; letter-spacing: .11em; }

			h2 {
				color: #263f56;
				font-family: map-get($fonts, opens-semibold);
				font-size: 16px;
				line-height: 1.25;
				margin: 2px 0 0;
				max-width: 440px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.modal-close { background: #f1f5f8; height: 32px; min-width: 32px; width: 32px; }
			.modal-close .icon { color: #526a7e; font-size: 18px; }
		}
	}
	.content-modal {
		background: #f6f8fb;
		height: calc(100vh - 66px);
		overflow: auto;
		padding-bottom: 78px;
	}
	@media (max-width: 700px) {
		.header-modal { min-height: 58px; padding: 5px 10px; }
		.header-modal .header-title { height: 48px; }
		.header-modal .header-title h2 { font-size: 14px; max-width: 220px; }
		.content-modal { height: calc(100vh - 58px); }
	}
</style>

<style lang="scss">
/* El cuerpo del modal llega por slot, así que va sin `scoped`. */
.content-modal {
	@include form-fields;

	.container { padding-top: 14px; }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/action-sidebar.vue